export default __webpack_public_path__ + "static/media/13.31.47f64072.jpg";